import React from "react";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Trans } from "react-i18next";
import Container from "@material-ui/core/Container";
import AppBar from "../../Components/AppBar";
import { Skeleton } from "@material-ui/lab";
import { useAPI } from "../../../../lib/common";

export default () => {
  const [data, isLoading] = useAPI("/api/webshop/privacy-policy");

  // Privacy policy might contain html:
  return (
    <MobilePage>
      <AppBar />
      <PageHeader>
        <Trans>Privacy policy</Trans>
      </PageHeader>

      <Container>
        {isLoading && <TextSkeleton />}
        {!isLoading && (
          <div
            dangerouslySetInnerHTML={{
              __html: data.data.privacyPolicy.replace(/\n/g, "<br />"),
            }}
          />
        )}
      </Container>
    </MobilePage>
  );
};

const TextSkeleton = () => {
  return (
    <>
      <Skeleton variant="text" />
      <Skeleton variant="text" />
      <Skeleton variant="text" />
      <br />
      <Skeleton variant="text" />
      <Skeleton variant="text" />
    </>
  );
};
